import { useHistory } from "react-router-dom";
import { Button, Card, CardContent, Typography } from "@common-ui/ui";
import { AddCircle, Edit } from "@mui/icons-material";
import { Table } from "../../components/Table/Table";
import checkTableValue from "../../utils/checkTableValue";
import checkTableImage from "../../utils/checkTableImage";
import AssetTableEnum from "../../enums/AssetTableEnum";
import { CompleteAssetDialog } from "./CompleteAssetDialog";
import { useState } from "react";
import { CustomerPlaceDialog } from "../../components/ScopingHeader/CustomerPlaceDialog";

function createData(props, router) {
  return {
    ...props,
    redirect: ({ row }) =>
      router.push({ pathname: `/edit-asset/${row?.orgId}/${row?.system_id}` }),
    columns: [
      {
        width: 100,
        field: "image_url",
        headerName: AssetTableEnum.ASSET_IMAGE,
        align: "center",
        sortable: false,
        renderCell: (params) => checkTableImage(params?.value),
      },
      {
        flex: 1,
        field: "name",
        headerName: AssetTableEnum.ASSET_NAME,
        renderCell: (params) => checkTableValue(params?.value),
      },
      {
        flex: 1,
        field: "id",
        headerName: AssetTableEnum.ASSET_ID,
        renderCell: (params) => checkTableValue(params?.value),
      },
      {
        flex: 1,
        field: "make",
        headerName: AssetTableEnum.MAKE,
        renderCell: (params) => checkTableValue(params?.value),
      },
      {
        flex: 1,
        field: "model",
        headerName: AssetTableEnum.MODEL,
        renderCell: (params) => checkTableValue(params?.value),
      },
      {
        flex: 1,
        field: "description",
        headerName: AssetTableEnum.DESCRIPTION,
        renderCell: (params) => checkTableValue(params?.value),
      },
      // {
      //   flex: 1,
      //   field: "disposition",
      //   headerName: AssetTableEnum.DISPOSITION,
      //   renderCell: (params) => checkTableValue(params?.value),
      // },
      {
        width: 100,
        field: "action",
        headerName: AssetTableEnum.ACTIONS,
        sortable: false,
        renderCell: (params) => {
          return (
            <Edit
              size="small"
              onClick={() =>
                router.push({
                  pathname: `/edit-asset/${params?.row?.orgId}/${params?.row?.system_id}`,
                })
              }
            />
          );
        },
      },
    ],
  };
}

export const AssetTableView = (props) => {
  const router = useHistory();
  const assetCount = props.rows ? props.rows?.length : 0;
  const [openCompleteAssetDialog, setOpenCompleteAssetDialog] = useState(false);
  const [openCreateDialog, setOpenCreateDialog] = useState(false);

  return (
    <Card>
      {props?.isShowTableHeader && (
        <CardContent
          sx={{
            display: "flex",
            justifyContent: "space-between",
            padding: ".5rem 1rem",
            alignItems: "center",
          }}
        >
          <Typography variant="h5" component="div">
            Assets: ({assetCount})
          </Typography>
          {
            <Button
              size="medium"
              type="button"
              variant="text"
              startIcon={<AddCircle />}
              sx={{ ml: 2, color: (theme) => theme.palette.grey[700] }}
              onClick={() => {
                setOpenCompleteAssetDialog(true);
              }}
            >
              Add Asset
            </Button>
          }
        </CardContent>
      )}
      <Table data={createData(props, router)} rowSize={props.rowSize} />
      {props?.isShowTableHeader && (
        <>
          <CompleteAssetDialog
            open={openCompleteAssetDialog}
            handleClose={() => {
              setOpenCompleteAssetDialog(false);
              props.setNewCustomer(null);
              props.setNewPlaceParent(null);
            }}
            currentOrgId={props.orgId}
            newCustomer={props.customer}
            newPlaceParent={props.newPlaceParent}
            setOpenCreateDialog={() => setOpenCreateDialog(true)}
            init={props.init}
          />
          <CustomerPlaceDialog
            open={openCreateDialog}
            handleClose={() => {
              setOpenCreateDialog(false);
              props.setNewCustomer(null);
              props.setNewPlaceParent(null);
            }}
            currentOrgId={props.orgId}
            setCustomer={props.setCustomer}
            setPlaces={props.setPlaces}
            customer={props.customer}
            places={props.places}
            setNewCustomer={props.setNewCustomer}
            placesParent={props.placesParent}
            setPlacesParent={props.setPlacesParent}
            setNewPlaceParent={props.setNewPlaceParent}
            setOpenCompleteWorkEventDialog={() =>
              setOpenCompleteAssetDialog(true)
            }
            // handleModal={handleModal}
            setIsLoading={props.setIsLoading}
          />
        </>
      )}
    </Card>
  );
};

AssetTableView.defaultProps = {
  isShowTableHeader: true,
};
